
export default {
  SET_REPORT_DETAILS(state, data) {
    state.reportDetails = data;
  },
  SET_CONFIRMOR_LIST(state, data) {
    state.confirmorList = data;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
}
